import React from "react";
import { WfControlSwitcher } from "./WfControlSwitcher";
import { FieldValues, SubmitHandler, UseFormReturn } from "react-hook-form";
import { WfFormRendererContextProvider } from "../../contexts/WfFormRendererContext";

export function WfFormRenderer({
  form,
  advanceForm,
  onSubmit,
}: Readonly<{
  form: UseFormReturn;
  advanceForm: AdvanceForm | null;
  onSubmit: SubmitHandler<FieldValues>;
}>) {

  return (
    <WfFormRendererContextProvider form={form}>
      <div style={{ width: "100%", fontSize: "20px" }}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          {advanceForm && <WfControlSwitcher advanceForm={advanceForm} />}
        </form>
      </div>
    </WfFormRendererContextProvider>
  );
}
